import styled from 'styled-components'
import { motion } from 'framer-motion'
import { CLICKABLE_COLOR, FONT_BASE_COLOR, GREY_BACKGROUND, SELECTED_ACTIVE_COLOR } from '@CSSVars/colors'

export const _TabsContainer = styled.div`
  padding: 4px;
  display: flex;
  flex-direction: row;
  margin-right: 0 !important;
  overflow: hidden;
  border: none;
  background: ${GREY_BACKGROUND};
  border-radius: 10px;
  width: fit-content;

`

export const _Tab = styled.button`
  height: 36px;
  border: none;
  background-color: transparent;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
  padding: 0 12px;

  ${({ isPrint }) => (
    isPrint ?
      `
        @media print {
          display: none;
        }
      ` : ''
  )}

`

export const _Label = styled.div`
  position: relative;
  white-space: nowrap;
  font-size: ${({ isActive }) => (isActive ? '14px' : 'inherit')};
  color: ${({ isActive, dropdown }) => (isActive ? dropdown ? 'white' : CLICKABLE_COLOR : FONT_BASE_COLOR)};
  &:hover {
    color: ${CLICKABLE_COLOR};
  }
  &:active {
    color: ${SELECTED_ACTIVE_COLOR};
  }

`
export const _Slider = styled(motion.span)`
  background: white;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  box-shadow: 0px 4px 8px 0px #00000026;

`
